// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VXzxe0QJlyEbf40kCAQy{height:22px}.kAaBQJrrsgQDaIreK5of{padding:0 2px;line-height:15px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `VXzxe0QJlyEbf40kCAQy`,
	"text": `kAaBQJrrsgQDaIreK5of`
};
export default ___CSS_LOADER_EXPORT___;
